/** Shared license display utilities for directory components */

export const LICENSE_COLORS: Record<string, string> = {
  'certified general': 'bg-rose-100 text-rose-800 border-rose-200 dark:bg-rose-950 dark:text-rose-200 dark:border-rose-800',
  'certified residential': 'bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-950 dark:text-blue-200 dark:border-blue-800',
  'licensed': 'bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950 dark:text-amber-200 dark:border-amber-800',
  'trainee': 'bg-gray-100 text-gray-700 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700',
};

export function getLicenseColor(licenseType: string): string {
  const key = licenseType.toLowerCase();
  for (const [pattern, color] of Object.entries(LICENSE_COLORS)) {
    if (key.includes(pattern)) return color;
  }
  return LICENSE_COLORS['licensed'];
}

export function isLicenseExpired(expirationDate: string | null): boolean {
  if (!expirationDate) return false;
  return new Date(expirationDate) < new Date();
}
